<template>
  <div class="cards d-grid" :class="`${resourceType}_cards`" style="gap: 1rem" :style="getGridStyle(resource.meta.config.component?.cols)">
    <Link
      v-for="(model, key) in resource.data"
      :key="key"
      :href="route(`${routePrefix}.${resourceType}.show`, model.data.id)"
      class="card overflow-hidden product">
      <div v-if="options.extra" class="card-header" style="color: var(--primary-color)">
        {{ options.extra.title }}
        <presentation-field
          :column="''"
          :column-type="'date'"
          :mutation="'date'"
          :show-id="false"
          :resource-type="resourceType"
          :value="options.extra.data[key]"
          :options="{ showCalendar: false }"
          style="color: var(--primary-color)"
        ></presentation-field>
      </div>
      <div class="card-img-top card-img text-center">
        <img
          v-if="model.data.attributes.image_preview_url || options.placeholder_image"
          :src="model.data.attributes.image_preview_url || options.placeholder_image"
          style="object-fit: contain"
        />
        <div
          v-else-if="model.data.attributes.icon_class ?? resource.meta.decoration.attributes"
          class="d-flex align-items-center justify-content-center"
          style="height:8rem;"
        >
          <colored-icon
            style="font-size: 3rem;"
            :icon-class="model.data.attributes.icon_class"
            :color="model.data.attributes.icon_color"
            :shadow="false"
          ></colored-icon>
        </div>
      </div>
      <div class="card-body text-center">
        <h5 class="card-title flex-grow-1 fs-5 fw-bold">
          {{ model.data.attributes[options.title_key] }}
        </h5>
        <p v-if="resource.meta.config.component.subtitle_key" class="card-text fs-6">
          {{ options.subtitle_prefix }}
          <presentation-field
            :column="resource.meta.config.component.subtitle_key"
            :column-type="meta.columns[resource.meta.config.component.subtitle_key]"
            :element="getElement(resource.meta.config.component.subtitle_key, 'display', meta)"
            :mutation="meta.elementTypes[resource.meta.config.component.subtitle_key].collection"
            :resource-type="resourceType"
            :show-id="$page.props.user.roles.includes('tech')"
            :value="model.data.attributes[resource.meta.config.component.subtitle_key]"
          ></presentation-field>
        </p>
      </div>
    </Link>
  </div>
</template>

<script>
import PresentationField from '@kanrisha/components/Presentation/PresentationField';
import { Link } from '@inertiajs/vue3';
import useResource from '@kanrisha/composables/useResource';
import ColoredIcon from "@kanrisha/components/Icons/ColoredIcon";

export default {
  components: {
    ColoredIcon,
    Link,
    PresentationField,
  },
  props: {
    options: { type: Object, default: () => {} },
    resource: { type: Object, default: () => {} },
    name: { type: String, default: 'default' },
    pagination: { type: Boolean, default: () => true }, // deprecated: this should go on options or config
  },
  emits: ['addToast', 'updatePicked', 'update:data', 'update:relation', 'trigger:refresh'],
  setup(props) {
    const { getElement, meta, resourceType } = useResource(props, props.resource);

    const getGridStyle = (cols) => {
      return 'grid-template-columns: repeat(' + (cols ?? 4) + ', minmax(0, 1fr))';
    };

    return {
      getElement,
      getGridStyle,
      meta,
      resourceType,
    };
  },
};
</script>
